import PropTypes from 'prop-types';
import React from 'react';

import { withRouter } from 'react-router-dom';

import qs from "qs";

const HISTORY_SIZE_SPARKLINE = 400;
const RESOLUTION = 10;
const DEBUG = false;

class ChartChellComponent extends React.Component { 

    constructor() {
        super();
        this.openChart = this.openChart.bind(this);
        this.setRef = this.setRef.bind(this);
    }

    openChart () {
        this.props.history.push({
            pathname:"/devices/" + this.context.uuid + "/chart-" + encodeURIComponent(this.context.basePath + this.props.chartPath),
            search: "?" + qs.stringify({
                name: this.props.chartTitle ? this.props.chartTitle : this.context.constructTitle(this.props)
            })
        });
    }

    setRef (el) {
        if (el && this.chartEl) {
            return;
        }
        if (!el) {
            this.componentWillUnmount();
            this.chartEl = null;
            return;
        }
        this.chartEl = el;

        var sparkline = new BG.charts.Sparkline({
            'element': el,
            'width': 80,
            'height': 21,
            'interval': RESOLUTION*1000,
            'span':'i',
            'upColor':'#999',
            'downColor': '#999',
            'color': '#999'
        });

        this.sparkline = sparkline.set('timeseries', 'OmSense(' + this.context.basePath + this.props.chartPath+ ',120,' + encodeURIComponent(this.props.chartTitle ? this.props.chartTitle : this.context.constructTitle(this.props)) + ',false)');

    }

    componentWillUnmount () {
        if (this.subscription) {
            this.context.p.unsubscribeDS(this.updateInDS, this.subscription);
            this.subscription = null;
        }

    }

    render() {
        return (
            <td className="sparkline"><div style={{width: 80, height: 21}} ref={this.setRef} onClick={this.openChart}></div></td>
        );
    }
}

ChartChellComponent.contextTypes = {
    basePath: PropTypes.string,
    t: PropTypes.func.isRequired,
    p: PropTypes.object.isRequired,
    uuid: PropTypes.string,
    constructTitle: PropTypes.func
};


export default withRouter(ChartChellComponent);
